import dataLayerHelper from '../helpers/dataLayer';

const $cartModal = $('.js-cart-modal');

const cartModal = {
  initialize() {
    if (!$cartModal.length) {
      return;
    }

    $cartModal.on('click', '.js-cart-modal-to-related-product', () => {
      this.shootEvent('Winkelwagen Popup', 'click', 'Naar gerelateerd product');
    });

    $cartModal.on('click', '.js-cart-modal-add-related-product', () => {
      this.shootEvent('Winkelwagen Popup', 'click', 'Gerelateerd product toegevoegd');
    });

    $cartModal.on('click', '.js-cart-modal-continue-shopping', () => {
      this.shootEvent('Winkelwagen Popup', 'click', 'Verder winkelen');
    });

    $cartModal.on('click', '.js-cart-modal-to-cart', () => {
      this.shootEvent('Winkelwagen Popup', 'click', 'Naar winkelwagen');
    });

    $cartModal.on('hidden.bs.modal', () => {
      this.shootEvent('Winkelwagen Popup', 'click', 'Popup gesloten');
    });
  },

  /**
   * Shoot event to Analytics
   * @param  {string} category - Category of the event
   * @param  {string} action - Action of the event (default: 'click')
   * @param  {string} label - Label of the event (default: '')
   * @param  {string} value - Value of the event (default: '')
   * @returns {void}
   */
  shootEvent(category, action = 'click', label = '', value = '') {
    dataLayerHelper.event(category, action, label, value);
  },
};

export default cartModal;
